<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
        <circle r=400 cx=480 cy=-480 fill=currentColor />
    </svg>
</template>